import Loadable from '@townsquare/loadable';
import type { RouteContext } from '@townsquare/router/routing-types';
import { aggTeamsDirectoryRoute } from '@townsquare/routes/agg-teams-directory-view';
import { tqlExplainerAggResource } from '@townsquare/tql/agg/resource';

import { cleanUpTeamsSkillNudgeResource } from './resources/clean-up-teams-skill-nudge';
import { teamDirectoryResource } from './resources/team-directory';
import { teamDirectoryTableResource } from './resources/team-directory-table';

const TeamsDirectoryLoadable = Loadable<RouteContext, any>({
	loader: () => import(/* webpackChunkName: "agg-teams-directory-view" */ './AggTeamDirectory'),
	loading: () => null,
});

aggTeamsDirectoryRoute.component = TeamsDirectoryLoadable;
aggTeamsDirectoryRoute.relayEnvironment = 'agg';
aggTeamsDirectoryRoute.resources = [
	teamDirectoryResource,
	teamDirectoryTableResource,
	tqlExplainerAggResource,
	cleanUpTeamsSkillNudgeResource,
];
export const aggTeamsDirectoryRouterRoute = aggTeamsDirectoryRoute;
